import { Box, Grid, Hidden, Typography, useTheme } from "@mui/material";
import styles from "./css/AboutGadgetBuilder.module.css";
import { GadgetBuilderGuide } from "./components/GadgetBuilderGuide";
import InstructionManualImage from "../../images/Instruction-manual.png";
import MobileTestingImage from "../../images/Mobile-testing.png";
import { useEffect } from "react";
import { InfoCard } from "../../components/InfoCard/InfoCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faGlobe,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { update } from "../../common/state/Slices/HeaderMenuSlice";
import { Routes } from "../../routes/routes";
import { useAppDispatch } from "../../common/state/hooks";
import { faJava } from "@fortawesome/free-brands-svg-icons";
import { GIFrameModal } from "../../components/GIframeModal";
import { Link } from "react-router-dom";

declare const genv: any;
const recipeInfoTextFirstLine =
  "Explore the core features of Build Agent. Consider printing or displaying on a separate screen for a distraction-free Build Agent Dashboard experience.";
const recipeInfoTextSecondLine =
  "Dive into the agent-building journey with a concise video. Launch Agent Builder now.";

export const AboutGadgetBuilder = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(
      update({
        selectedMenu: Routes.ABOUT_GADGET_BUILDER,
      })
    );
  }, [dispatch]);

  return (
    <>
      <Box className={styles.topBannerArea}>
        <div className={styles.topBannerAreaContainer}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h1"
                fontWeight={600}
                gutterBottom
                data-testid="getting-started-header-text"
              >
                GETTING STARTED WITH
                <span
                  style={{ color: theme.palette.primary.main, marginLeft: 12 }}
                >
                  AGENT BUILDER 2X
                </span>
              </Typography>

              <Typography
                variant="body1"
                data-testid="getting-started-info-text-first"
                gutterBottom
              >
                {recipeInfoTextFirstLine}
              </Typography>
              <Typography
                variant="body1"
                data-testid="getting-started-info-text-second"
                gutterBottom
              >
                {recipeInfoTextSecondLine}
              </Typography>
            </Grid>
          </Grid>
          <div className={styles.buttonContainer}>
            {/* <GButton
              id="launch-gb-button"
              data-testid="launch-gb-btn"
              variant="contained"
              disableElevation
              color="primary"
              size="large"
              endIcon={<FontAwesomeIcon icon={faRocket} />}
              className={styles.launchButton}
              onClick={launchGadgetBuilder}
            >
              Launch
            </GButton> */}
            <GIFrameModal 
              url={genv.ONLINE_GADGET_BUILDER_GUIDE_VIDEO_URL}
              title="Watch Demo"
              icon={faEye}
            />
          </div>
        </div>
      </Box>
      <Hidden smDown>
        <GadgetBuilderGuide />
      </Hidden>
      <div className={styles.cardContainer}>
        <Grid container spacing={3} className={styles.grid}>
          <Grid item xs={12} md={6}>
            <InfoCard
              cardImage={InstructionManualImage}
              icon={
                <FontAwesomeIcon
                  icon={faUpRightFromSquare}
                  className={styles.openNewtabIcon}
                />
              }
              headerText="GARUDIFY YOUR TOOLS"
              infoText="Effortlessly integrate your tools into the Garuda2x ecosystem using our versatile SDK. Our step-by-step manuals guide you through the process of “Garudifying” your agents, ensuring seamless compatibility with the Garuda2x platform.Explore the guides tailored to your tools:"
              buttonText="Explore"
              dataTestId="garuda-sdk-card"
              isDisabled={true}
              actionButtons={[
                <GIFrameModal
                  url={genv.JAVA_SDK_GUIDE_URL}
                  title="Java Tools"
                  icon={faJava}
                />,
                <GIFrameModal
                  url={genv.WEB_SDK_GUIDE_URL}
                  title="Web Tools"
                  icon={faGlobe}
                />,
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoCard
              cardImage={MobileTestingImage}
              icon={
                <FontAwesomeIcon
                  icon={faUpRightFromSquare}
                  className={styles.openNewtabIcon}
                />
              }
              headerText="GARUDA SDK"
              infoText="Unlock the potential of your software with Garuda's language-independent API. Connect your tools as agents effortlessly and make them available in Garuda2x, accessible through the Garuda2x Portal."
              buttonText="Guide"
              dataTestId="recipe-player-guide-card"
              isDisabled={true}
              actionButtons={[]}
              footerText={<Typography variant="h3" mt={4} color="#939191">Need further assistance or have questions? <span><Link to={"/"+Routes.HELP_SUPPORT} style={{color: "#44bcdb"}}>Contact us</Link></span> for expert guidance and support!</Typography>}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
